import { useEffect } from "react";
import { useRouter } from "next/router";
import { useProfile } from "@/context/ProfileContext";
import { useUser } from "@/context/UserContext";
import LoadingScreen from "./LoadingScreen";

/** Routes that must stay reachable before a profile is picked. */
const OPEN_ROUTES = ["/perfiles", "/login", "/payment-result"];

const isOpenRoute = (pathname) =>
  OPEN_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  ) || pathname.startsWith("/admin");

/**
 * A profile is chosen once per tab; without a selection the user is sent to
 * the picker instead of silently landing on someone else's RUC.
 */
const ProfileGate = ({ children }) => {
  const router = useRouter();
  const { user } = useUser();
  const { needsProfileSelection, hasLoadedOnce } = useProfile();
  const guarded = !!user && !isOpenRoute(router.pathname);
  const redirect = guarded && needsProfileSelection;

  useEffect(() => {
    if (redirect) router.replace("/perfiles");
  }, [redirect, router]);

  if (!user) return children;
  if (redirect || (guarded && !hasLoadedOnce)) return <LoadingScreen isLoading />;

  return children;
};

export default ProfileGate;
